import { useQuery } from '@tanstack/react-query';

import { pricingSearchOptions } from '../data-provider';
import type { PricingsFiltersApi } from '../models';

export const usePricings = (filters?: PricingsFiltersApi) => useQuery(pricingSearchOptions(filters));
